/* eslint-disable jsx-a11y/anchor-is-valid */
import { FC, useEffect } from 'react'
import React, { useState } from 'react';
import { PageTitle } from '../../../_metronic/layout/core'
import { LanguageHelp, getConfig } from '../../../_metronic/helpers/LanguageHelper'
import {
  ChartsWidget1,
  ChartsWidget1Dto,
  ChartsWidgetLine,
  ChartsWidgetLineDto,
  TablesWidget5,
  ListsWidget6,
  CardsWidget17,
  CardsWidget17Dto,
  TablesWidget5Dto,
  ListsWidget6Dto,
  WordCloud,
  WordCloudDto,
  TablesWidget14,
  TablesWidget14Dto,
  ChartsWidgetBubble,
  ChartsWidget2,
} from '../../../_metronic/partials/widgets'
import * as requests from './_requests'
import { getColorCodeFromDivision } from '../../../_metronic/helpers/utility';
import { CardsWidget18, CardsWidget18Dto } from '../../../_metronic/partials/widgets/_new/cards/CardsWidget18';

// import {AuthModel} from './../../modules/auth/core/_models'
let initialStatus = {
  getCompetitorNames: false,
  getReviewSubjects: false,
  updateOverallSentimentDistribution: false,
  updateYourSentimentDistribution: false,
  updateCompetitionVolumeDistribution: false,
  updateChannel: false,
  updateTestSentimentCountByPlatforms: false,
  updateTestSentimentCountByCompetitors: false,
  updateSentimentByCompetitorsAndSubject: false,
  updateTestSentimentCountByMonths: false,
  updateTestSentimentCountByDays: false,
  updateNotification: false,
  // updateTokenForWordCloud: false, 
  // updateTokenForTable: false, 
  updateSubjectSentimentForWordCloud: false,
  updateSubjectSentimentForTable: false,
  // updateAutoClassSentimentForTable: false, 
  // updateAutoClassSentimentForWordCloud: false, 
}
let updateStatus = JSON.parse(JSON.stringify(initialStatus));
const DashboardWrapper: FC = () => {
  const [reviewSubjects, updateReviewSubjects] = React.useState([]);
  const [overallSentimentDistribution, updateOverallSentimentDistribution] = React.useState(new CardsWidget17Dto());
  const [yourSentimentDistribution, updateYourSentimentDistribution] = React.useState(new CardsWidget17Dto());
  const [competitionVolumeDistribution, updateCompetitionVolumeDistribution] = React.useState(new CardsWidget18Dto());
  const [channels, updateChannel] = React.useState(new TablesWidget5Dto());
  const [competitors, updateCompetitors] = React.useState([]);
  const [channels_Date, updateChannel_Date] = React.useState(LanguageHelp('Last 30 days'));
  const [channels_Subject, updateChannel_Subject] = React.useState(LanguageHelp('All Subjects'));
  const [channels_ChannelType, updateChannel_ChannelType] = React.useState(LanguageHelp('All Platforms'));
  const [channels_Competitor, updateChannel_Competitor] = React.useState(LanguageHelp('All Competitors'));
  const [sentimentByMonths, updateTestSentimentCountByMonths] = React.useState([new ChartsWidget1Dto()]);
  const [sentimentByCompetitors, updateTestSentimentCountByCompetitors] = React.useState([new ChartsWidget1Dto()]);
  const [sentimentByCompetitors_Date, updateSentimentByCompetitors_Date] = React.useState(LanguageHelp('Last 30 days'));
  const [sentimentByCompetitors_Subject, updateSentimentByCompetitors_Subject] = React.useState(LanguageHelp('All Subjects'));
  const [sentimentByCompetitorsAndSubjects, updateSentimentByCompetitorsAndSubject] = React.useState([new ChartsWidget1Dto()]);
  const [sentimentByCompetitorsAndSubjects_Date, updateSentimentByCompetitorsAndSubjects_Date] = React.useState(LanguageHelp('Last 30 days'));
  const [sentimentByCompetitorsAndSubjects_Subject, updateSentimentByCompetitorsAndSubjects_Subject] = React.useState(LanguageHelp('All Subjects'));
  const [sentimentByPlatforms, updateTestSentimentCountByPlatforms] = React.useState([new ChartsWidget1Dto()]);
  const [sentimentByPlatforms_Date, updateSentimentByPlatforms_Date] = React.useState(LanguageHelp('Last 30 days'));
  const [sentimentByPlatforms_Competitor, updateSentimentByPlatforms_Competitor] = React.useState(LanguageHelp('All Competitors'));
  const [sentimentByDays, updateTestSentimentCountByDays] = React.useState([new ChartsWidgetLineDto()]);
  const [notifications, updateNotification] = React.useState([new ListsWidget6Dto()]);
  // const [tokensForWordCloud, updateTokenForWordCloud] = React.useState([new WordCloudDto()]);
  // const [tokensForTable, updateTokenForTable] = React.useState(new TablesWidget14Dto());
  const [subjectSentimentsForWordCloud, updateSubjectSentimentForWordCloud] = React.useState([new WordCloudDto()]);
  const [subjectSentimentsForTable, updateSubjectSentimentForTable] = React.useState(new TablesWidget14Dto());
  // const [autoClassSentimentsForWordCloud, updateAutoClassSentimentForWordCloud] = React.useState([new WordCloudDto()]);
  // const [autoClassSentimentsForTable, updateAutoClassSentimentForTable] = React.useState(new TablesWidget14Dto());

  let _overallSentimentDistributionData: any;
  let _yourSentimentDistributionData: any;
  let _competitionVolumeDistributionData: any;
  let _channelData: any;
  let _sentimentByCompetitorData: any;
  let _sentimentByPlatformData: any;
  let _sentimentByCompetitorAndSubjectData: any;
  let _sentimentByMonthData: any;
  let _sentimentByDayData: any;
  let _notificationData: any;
  let _subjectSentimentForWordCloudData: any;
  let _subjectSentimentForTableData: any;

  const getCompetitorNames = async () => {
    try {
      const _data = await requests.GetCompetitorNames()

      _data.unshift(LanguageHelp('All Competitors'))
      updateCompetitors(_data);
      updateStatus.getCompetitorNames = true;
    } catch (error) {
      console.error(error)
    }
  }

  const getReviewSubjects = async () => {
    try {
      const _data = await requests.GetReviewSubjects()

      _data.unshift(LanguageHelp('All Subjects'))
      updateReviewSubjects(_data);
      updateStatus.getReviewSubjects = true;
    } catch (error) {
      console.error(error)
    }
  }

  const updateOverallSentimentDistributionFunction = async (date: string = LanguageHelp('Last 30 days'), fromButton: boolean = true) => {
    try {
      // updateOverallSentimentDistribution({ ...new CardsWidget17Dto(), ...{ allCount: -1 } });

      const _data = await requests.GetSentimentDistribution(date, false)

      if (fromButton || updateStatus.updateOverallSentimentDistribution === true) {
        updateOverallSentimentDistribution(_data);
      } else {
        _overallSentimentDistributionData = _data;
        updateStatus.updateOverallSentimentDistribution = true;
      }
    } catch (error) {
      console.error(error)
    }
  }

  const updateYourSentimentDistributionFunction = async (date: string = LanguageHelp('Last 30 days'), fromButton: boolean = true) => {
    try {
      // updateYourSentimentDistribution({ ...new CardsWidget17Dto(), ...{ allCount: -1 } });

      const _data = await requests.GetSentimentDistribution(date)

      if (fromButton || updateStatus.updateYourSentimentDistribution === true) {
        updateYourSentimentDistribution(_data);
      } else {
        _yourSentimentDistributionData = _data;
        updateStatus.updateYourSentimentDistribution = true;
      }
    } catch (error) {
      console.error(error)
    }
  }

  const updateCompetitionVolumeDistributionFunction = async (date: string = LanguageHelp('Last 30 days'), fromButton: boolean = true) => {
    try {
      // updateCompetitionVolumeDistribution({ ...new CardsWidget18Dto(), ...{ allCount: -1 } });

      const _data = await requests.GetCompetitionVolumeDistribution(date)

      if (fromButton || updateStatus.updateCompetitionVolumeDistribution === true) {
        updateCompetitionVolumeDistribution(_data);
      } else {
        _competitionVolumeDistributionData = _data;
        updateStatus.updateCompetitionVolumeDistribution = true;
      }
    } catch (error) {
      console.error(error)
    }
  }

  const updateChannelFunction = async (data: string = LanguageHelp('Last 30 days'), type: string = "date", fromButton: boolean = true) => {
    try {
      // updateChannel({ ...new TablesWidget5Dto(), ...{ allCount: 1 } });

      var date = channels_Date, subject = channels_Subject, channelType = channels_ChannelType, competitorName = channels_Competitor;
      if (type === 'subject') { updateChannel_Subject(data); subject = data; }
      if (type === 'channelType' || type === 'channeltype') { updateChannel_ChannelType(data); channelType = data; }
      if (type === 'date') { updateChannel_Date(data); date = data; }
      if (type === 'competitor') { updateChannel_Competitor(data); competitorName = data; }

      const _data = await requests.GetTestSentimentRateByChannels(date, subject, channelType, competitorName)

      if (fromButton || updateStatus.updateChannel === true) {
        updateChannel(_data);
      } else {
        _channelData = _data;
        updateStatus.updateChannel = true;
      }
    } catch (error) {
      console.error(error)
    }
  }

  const [isDownloadContinue_TestSentimentRateByChannels, updateIsDownloadContinue_TestSentimentRateByChannels] = React.useState(false);
  const downlodTestSentimentRateByChannels = async () => {
    try {
      updateIsDownloadContinue_TestSentimentRateByChannels(true)
      const _data = await requests.DownloadTestSentimentRateByChannels()
      updateIsDownloadContinue_TestSentimentRateByChannels(false)
    } catch (error) {
      console.error(error)
    }
  }

  const [isDownloadContinue_TestCountBySentimentAndCompetitor, updateIsDownloadContinue_TestCountBySentimentAndCompetitor] = React.useState(false);
  const downlodTestCountBySentimentAndCompetitor = async () => {
    try {
      updateIsDownloadContinue_TestCountBySentimentAndCompetitor(true)
      const _data = await requests.DownloadTestCountBySentimentAndCompetitor()
      updateIsDownloadContinue_TestCountBySentimentAndCompetitor(false)
    } catch (error) {
      console.error(error)
    }
  }

  const updateTestSentimentCountByCompetitorsFunction = async (data: string = LanguageHelp('Last 30 days'), type: string = "date", fromButton: boolean = true) => {
    try {
      // updateTestSentimentCountByCompetitors([new ChartsWidget1Dto()]);

      var date = sentimentByCompetitorsAndSubjects_Date, subject = sentimentByCompetitorsAndSubjects_Subject;
      if (type === 'subject') { updateSentimentByCompetitorsAndSubjects_Subject(data); subject = data; }
      if (type === 'date') { updateSentimentByCompetitorsAndSubjects_Date(data); date = data; }

      const _data = await requests.GetTestSentimentCountByCompetitors(date, subject)

      if (fromButton || updateStatus.updateTestSentimentCountByCompetitors === true) {
        updateTestSentimentCountByCompetitors(_data);
      } else {
        _sentimentByCompetitorData = _data;
        updateStatus.updateTestSentimentCountByCompetitors = true;
      }
    } catch (error) {
      console.error(error)
    }
  }

  const [isDownloadContinue_TestCountBySentimentAndPlatform, updateIsDownloadContinue_TestCountBySentimentAndPlatform] = React.useState(false);
  const downlodTestCountBySentimentAndPlatform = async () => {
    try {
      updateIsDownloadContinue_TestCountBySentimentAndPlatform(true)
      const _data = await requests.DownloadTestCountBySentimentAndPlatform()
      updateIsDownloadContinue_TestCountBySentimentAndPlatform(false)
    } catch (error) {
      console.error(error)
    }
  }

  const updateTestSentimentCountByPlatformsFunction = async (data: string = LanguageHelp('Last 30 days'), type: string = "date", fromButton: boolean = true) => {
    try {
      // updateTestSentimentCountByPlatforms([new ChartsWidget1Dto()]);

      var date = sentimentByPlatforms_Date, competitor = sentimentByPlatforms_Competitor;
      if (type === 'subject') { updateSentimentByPlatforms_Competitor(data); competitor = data; }
      if (type === 'date') { updateSentimentByPlatforms_Date(data); date = data; }

      const _data = await requests.GetTestSentimentCountByPlatforms(date, competitor)

      if (fromButton || updateStatus.updateTestSentimentCountByPlatforms === true) {
        updateTestSentimentCountByPlatforms(_data);
      } else {
        _sentimentByPlatformData = _data;
        updateStatus.updateTestSentimentCountByPlatforms = true;
      }
    } catch (error) {
      console.error(error)
    }
  }

  const [isDownloadContinue_TestCountBySentimentAndCompetitorAndSubject, updateIsDownloadContinue_TestCountBySentimentAndCompetitorAndSubject] = React.useState(false);
  const downlodTestCountBySentimentAndCompetitorAndSubject = async () => {
    try {
      updateIsDownloadContinue_TestCountBySentimentAndCompetitorAndSubject(true)
      const _data = await requests.DownloadTestCountBySentimentAndCompetitorAndSubject()
      updateIsDownloadContinue_TestCountBySentimentAndCompetitorAndSubject(false)
    } catch (error) {
      console.error(error)
    }
  }

  const updateTestSentimentCountByCompetitorsAndSubjectsFunction = async (data: string = LanguageHelp('Last 30 days'), type: string = "date", fromButton: boolean = true) => {
    try {
      // updateSentimentByCompetitorsAndSubject([new ChartsWidget1Dto()]);

      var date = sentimentByCompetitors_Date, subject = sentimentByCompetitors_Subject;
      if (type === 'subject') { updateSentimentByCompetitors_Subject(data); subject = data; }
      if (type === 'date') { updateSentimentByCompetitors_Date(data); date = data; }

      const _data = await requests.GetTestSentimentCountByCompetitorsAndSubjects(date, subject)

      if (fromButton || updateStatus.updateSentimentByCompetitorsAndSubject === true) {
        updateSentimentByCompetitorsAndSubject(_data);
      } else {
        _sentimentByCompetitorAndSubjectData = _data;
        updateStatus.updateSentimentByCompetitorsAndSubject = true;
      }
    } catch (error) {
      console.error(error)
    }
  }

  const [isDownloadContinue_TestCountBySentimentAndMonth, updateIsDownloadContinue_TestCountBySentimentAndMonth] = React.useState(false);
  const downlodTestCountBySentimentAndMonth = async () => {
    try {
      updateIsDownloadContinue_TestCountBySentimentAndMonth(true)
      const _data = await requests.DownloadTestCountBySentimentAndMonth()
      updateIsDownloadContinue_TestCountBySentimentAndMonth(false)
    } catch (error) {
      console.error(error)
    }
  }

  const updateTestSentimentCountByMonthsFunction = async (subject: string = "", fromButton: boolean = true) => {
    try {
      // updateTestSentimentCountByMonths([{ ...new ChartsWidget1Dto(), ...{ allCount: -1 } }]);

      const _data = await requests.GetTestSentimentCountByMonths(subject)

      if (fromButton || updateStatus.updateTestSentimentCountByMonths === true) {
        updateTestSentimentCountByMonths(_data);
      } else {
        _sentimentByMonthData = _data;
        updateStatus.updateTestSentimentCountByMonths = true;
      }
    } catch (error) {
      console.error(error)
    }
  }

  const updateTestSentimentCountByDaysFunction = async (subject: string = "", fromButton: boolean = true) => {
    try {
      // updateTestSentimentCountByDays([{...new ChartsWidgetLineDto(), ...{ allCount: -1 } }]);

      const _data = await requests.GetTestSentimentCountByDays(subject)

      if (fromButton || updateStatus.updateTestSentimentCountByDays === true) {
        updateTestSentimentCountByDays(_data);
      } else {
        _sentimentByDayData = _data;
        updateStatus.updateTestSentimentCountByDays = true;
      }
    } catch (error) {
      console.error(error)
    }
  }

  const [isDownloadContinue_TestCountBySentimentAndDay, updateIsDownloadContinue_TestCountBySentimentAndDay] = React.useState(false);
  const downlodTestCountBySentimentAndDay = async () => {
    try {
      updateIsDownloadContinue_TestCountBySentimentAndDay(true)
      const _data = await requests.DownloadTestCountBySentimentAndDay()
      updateIsDownloadContinue_TestCountBySentimentAndDay(false)
    } catch (error) {
      console.error(error)
    }
  }

  const updateNotificationFunction = async (fromButton: boolean = true) => {
    try {
      // updateNotification([new ListsWidget6Dto()]);

      const _data = await requests.GetNotifications()

      if (fromButton || updateStatus.updateNotification === true) {
        updateNotification(_data);
      } else {
        _notificationData = _data;
        updateStatus.updateNotification = true;
      }
    } catch (error) {
      console.error(error)
    }
  }

  // const updateTokensForWordCloudFunction = async (date: string = LanguageHelp('Last 30 days')) => {
  //   try {
  //     updateTokenForWordCloud([new WordCloudDto]);
  //     const _data = await requests.GetTokenListForWordCloudList(date)
  //     updateTokenForWordCloud(_data);
  //     updateStatus.updateTokenForWordCloud = true;
  //   } catch (error) {
  //     console.error(error)
  //   }
  // }

  // const updateTokenForTableFunction = async (date: string = LanguageHelp('Last 30 days')) => {
  //   try {
  //     const _data = await requests.GetTokenForTableList(date)
  //     updateTokenForTable(_data);
  //     updateStatus.updateTokenForTable = true;
  //   } catch (error) {
  //     console.error(error)
  //   }
  // }

  // const [isDownloadContinue_TokensForTable, updateIsDownloadContinue_TokensForTable] = React.useState(false);
  // const downlodTokensForTable = async () => {
  //   try {
  //     updateIsDownloadContinue_TokensForTable(true)
  //     const _data = await requests.DownloadTokensForTable()
  //     updateIsDownloadContinue_TokensForTable(false)
  //   } catch (error) {
  //     console.error(error)
  //   }
  // }

  const updateSubjectSentimentsForWordCloudFunction = async (date: string = LanguageHelp('Last 30 days'), fromButton: boolean = true) => {
    try {
      updateSubjectSentimentForWordCloud([new WordCloudDto]);

      const _data = await requests.GetSubjectSentimentListForWordCloudList(date)

      if (fromButton || updateStatus.updateSubjectSentimentForWordCloud === true) {
        updateSubjectSentimentForWordCloud(_data);
      } else {
        _subjectSentimentForWordCloudData = _data;
        updateStatus.updateSubjectSentimentForWordCloud = true;
      }
    } catch (error) {
      console.error(error)
    }
  }

  const updateSubjectSentimentForTableFunction = async (date: string = LanguageHelp('Last 30 days'), fromButton: boolean = true) => {
    try {
      const _data = await requests.GetSubjectSentimentForTableList(date)

      if (fromButton || updateStatus.updateSubjectSentimentForTable === true) {
        updateSubjectSentimentForTable(_data);
      } else {
        _subjectSentimentForTableData = _data;
        updateStatus.updateSubjectSentimentForTable = true;
      }
    } catch (error) {
      console.error(error)
    }
  }

  const [isDownloadContinue_SubjectSentimentsForTable, updateIsDownloadContinue_SubjectSentimentsForTable] = React.useState(false);
  const downlodSubjectSentimentsForTable = async () => {
    try {
      updateIsDownloadContinue_SubjectSentimentsForTable(true)
      const _data = await requests.DownloadSubjectSentimentsForTable()
      updateIsDownloadContinue_SubjectSentimentsForTable(false)
    } catch (error) {
      console.error(error)
    }
  }

  // const updateAutoClassSentimentsForWordCloudFunction = async (date: string = LanguageHelp('Last 30 days')) => {
  //   try {
  //     updateAutoClassSentimentForWordCloud([new WordCloudDto]);
  //     const _data = await requests.GetAutoClassSentimentListForWordCloudList(date)
  //     updateAutoClassSentimentForWordCloud(_data);
  //     updateStatus.updateAutoClassSentimentForWordCloud = true;
  //   } catch (error) {
  //     console.error(error)
  //   }
  // }

  // const updateAutoClassSentimentForTableFunction = async (date: string = LanguageHelp('Last 30 days')) => {
  //   try {
  //     const _data = await requests.GetAutoClassSentimentForTableList(date)
  //     updateAutoClassSentimentForTable(_data);
  //     updateStatus.updateAutoClassSentimentForTable = true;
  //   } catch (error) {
  //     console.error(error)
  //   }
  // }

  // const [isDownloadContinue_AutoClassSentimentsForTable, updateIsDownloadContinue_AutoClassSentimentsForTable] = React.useState(false);
  // const downlodAutoClassSentimentsForTable = async () => {
  //   try {
  //     updateIsDownloadContinue_AutoClassSentimentsForTable(true)
  //     const _data = await requests.DownloadAutoClassSentimentsForTable()
  //     updateIsDownloadContinue_AutoClassSentimentsForTable(false)
  //   } catch (error) {
  //     console.error(error)
  //   }
  // }

  useEffect(() => {
    // Initiate charts
    updateYourSentimentDistribution({ ...new CardsWidget17Dto(), ...{ allCount: -1 } });
    updateOverallSentimentDistribution({ ...new CardsWidget17Dto(), ...{ allCount: -1 } });
    updateCompetitionVolumeDistribution({ ...new CardsWidget18Dto(), ...{ allCount: -1 } });
    updateChannel({ ...new TablesWidget5Dto(), ...{ allCount: 1 } });
    updateTestSentimentCountByPlatforms([new ChartsWidget1Dto()]);
    updateTestSentimentCountByCompetitors([new ChartsWidget1Dto()]);
    updateSentimentByCompetitorsAndSubject([{ ...new ChartsWidget1Dto(), ...{ allCount: -1 } }]);
    updateTestSentimentCountByMonths([{ ...new ChartsWidget1Dto(), ...{ allCount: -1 } }]);
    updateTestSentimentCountByDays([{ ...new ChartsWidgetLineDto(), ...{ allCount: -1 } }]);
    // updateNotification([new ListsWidget6Dto()]);
    // updateTokenForWordCloud([{ ...new WordCloudDto(), ...{ allCount: -1 } }]);
    // updateTokenForTable(new TablesWidget14Dto());
    updateSubjectSentimentForWordCloud([{ ...new WordCloudDto(), ...{ allCount: -1 } }]);
    updateSubjectSentimentForTable(new TablesWidget14Dto());

    getCompetitorNames();
    getReviewSubjects();
    updateOverallSentimentDistributionFunction(LanguageHelp('Last 30 days'), false);
    updateYourSentimentDistributionFunction(LanguageHelp('Last 30 days'), false);
    updateCompetitionVolumeDistributionFunction(LanguageHelp('Last 30 days'), false);
    updateChannelFunction(LanguageHelp('Last 30 days'), "date", false);
    updateTestSentimentCountByPlatformsFunction(LanguageHelp('Last 30 days'), "date", false);
    updateTestSentimentCountByCompetitorsFunction(LanguageHelp('Last 30 days'), "date", false);
    updateTestSentimentCountByCompetitorsAndSubjectsFunction(LanguageHelp('Last 30 days'), "date", false);
    updateTestSentimentCountByMonthsFunction("", false);
    updateTestSentimentCountByDaysFunction("", false);
    updateNotificationFunction(false);
    // updateTokenForTableFunction(LanguageHelp('Last 30 days'));
    updateSubjectSentimentsForWordCloudFunction(LanguageHelp('Last 30 days'), false);
    updateSubjectSentimentForTableFunction(LanguageHelp('Last 30 days'), false);
    // updateAutoClassSentimentForTableFunction(LanguageHelp('Last 30 days'));


    var intervalCheckStatus = setInterval(function () { // This check saves us a little bit from too much re-creation of our page
      if (updateStatus.updateOverallSentimentDistribution === true
        && updateStatus.updateYourSentimentDistribution === true
        && updateStatus.updateCompetitionVolumeDistribution === true
        && updateStatus.updateChannel === true
        && updateStatus.updateTestSentimentCountByPlatforms === true
        && updateStatus.updateTestSentimentCountByCompetitors === true
        && updateStatus.updateTestSentimentCountByMonths === true
        && updateStatus.updateTestSentimentCountByDays === true
        && updateStatus.updateNotification === true
        // && updateStatus.updateTokenForTable === true
        && updateStatus.updateSubjectSentimentForWordCloud === true
        && updateStatus.updateSubjectSentimentForTable === true
        // && updateStatus.updateAutoClassSentimentForTable === true
        && updateStatus.updateSentimentByCompetitorsAndSubject === true

      ) {
        updateOverallSentimentDistribution(_overallSentimentDistributionData);
        updateYourSentimentDistribution(_yourSentimentDistributionData);
        updateCompetitionVolumeDistribution(_competitionVolumeDistributionData);
        updateChannel(_channelData);
        updateTestSentimentCountByPlatforms(_sentimentByPlatformData);
        updateTestSentimentCountByCompetitors(_sentimentByCompetitorData);
        updateTestSentimentCountByMonths(_sentimentByMonthData);
        updateTestSentimentCountByDays(_sentimentByDayData);
        updateNotification(_notificationData);

        setTimeout(function(){
          updateSubjectSentimentForTable(_subjectSentimentForTableData);
          updateSentimentByCompetitorsAndSubject(_sentimentByCompetitorAndSubjectData);
          updateSubjectSentimentForWordCloud(_subjectSentimentForWordCloudData);
        }, 1000);

        // updateTokensForWordCloudFunction();
        // updateAutoClassSentimentsForWordCloudFunction();

        updateStatus = JSON.parse(JSON.stringify(initialStatus));
        clearInterval(intervalCheckStatus);
      }
    }, 300);
  }, []);

  return (
    <>
      <PageTitle breadcrumbs={[]}>{LanguageHelp('Dashboard')}</PageTitle>

      {/* begin::Row */}
      <div className='row g-5 g-xl-10 mb-5 mb-xl-10'>
        <div className='col-md-4 col-lg-4 col-xl-4 col-xxl-4'>
          <CardsWidget17
            id='idYourSentimentDistribution'
            className=''
            title={LanguageHelp('Your Sentiment Distribution')}
            name={LanguageHelp('Total Query')}
            firstText={LanguageHelp('Positive')}
            secondText={LanguageHelp('Negative')}
            thirdText={LanguageHelp('Neutral')}
            symbol=''
            functionSubmit={updateYourSentimentDistributionFunction}
            data={yourSentimentDistribution} />
        </div>
        <div className='col-md-4 col-lg-4 col-xl-4 col-xxl-4'>
          <CardsWidget17
            id='idOverallSentimentDistribution'
            className=''
            title={LanguageHelp('Overall Sentiment Distribution')}
            name={LanguageHelp('Total Query')}
            firstText={LanguageHelp('Positive')}
            secondText={LanguageHelp('Negative')}
            thirdText={LanguageHelp('Neutral')}
            symbol=''
            functionSubmit={updateOverallSentimentDistributionFunction}
            data={overallSentimentDistribution} />
        </div>
        <div className='col-md-4 col-lg-4 col-xl-4 col-xxl-4'>
          <CardsWidget18
            id='idCompetitionVolumeDistribution'
            className=''
            title={LanguageHelp('Competition Volume Distribution')}
            name={LanguageHelp('Total Query')}
            symbol=''
            height='325px'
            functionSubmit={updateCompetitionVolumeDistributionFunction}
            data={competitionVolumeDistribution} />
        </div>
      </div>
      {/* end::Row */}

      {/* begin::Row */}
      <div className='row g-5 g-xl-10 mb-5'>
        <div className='col-xl-6'>
          <ChartsWidget2
            id='sentimentByCompetitors'
            className='mb-5'
            data={sentimentByCompetitors}
            functionSubmit={updateTestSentimentCountByCompetitorsFunction}
            functionDownload={downlodTestCountBySentimentAndCompetitor}
            isDownloadContinue={isDownloadContinue_TestCountBySentimentAndCompetitor}
            texts={[LanguageHelp('Positive'), LanguageHelp('Negative'), LanguageHelp('Neutral')]}
            mainLabel={LanguageHelp('Competition Statistics')}
            sideLabel={LanguageHelp('Happiness Score Compared to Competitors')}
            options={reviewSubjects}
            selectedOption={sentimentByCompetitorsAndSubjects_Subject}
            selectedDate={sentimentByCompetitorsAndSubjects_Date}
            isHorizontal={true}
            height='325px'
            warnings={[
              { url: '/apps/artificial-intelligence/subjects', message: LanguageHelp("You can add subjects from the 'Artificial Intelligence/Subjects page.") },
              { url: '/crafted/channels', message: LanguageHelp("You can add competitors and turn on daily data collection from the 'Settings/Channels' page.") },
            ]}
            isCompetitorControl={true} />
        </div>
        <div className='col-xl-6'>
          <ChartsWidget1
            id='sentimentByCompetitors'
            className='mb-5'
            data={sentimentByCompetitors}
            functionSubmit={updateTestSentimentCountByCompetitorsFunction}
            functionDownload={downlodTestCountBySentimentAndCompetitor}
            isDownloadContinue={isDownloadContinue_TestCountBySentimentAndCompetitor}
            texts={[LanguageHelp('Positive'), LanguageHelp('Negative'), LanguageHelp('Neutral')]}
            mainLabel={LanguageHelp('Competition Statistics')}
            sideLabel={LanguageHelp('Sentiment Analysis Compared to Competitors')}
            options={reviewSubjects}
            selectedOption={sentimentByCompetitorsAndSubjects_Subject}
            selectedDate={sentimentByCompetitorsAndSubjects_Date}
            height='325px'
            warnings={[
              { url: '/apps/artificial-intelligence/subjects', message: LanguageHelp("You can add subjects from the 'Artificial Intelligence/Subjects page.") },
              { url: '/crafted/channels', message: LanguageHelp("You can add competitors and turn on daily data collection from the 'Settings/Channels' page.") },
            ]}
            isCompetitorControl={true} />
        </div>
      </div>
      {/* end::Row */}

      {/* begin::Row */}
      <div className='row g-5 g-xl-10 mb-5'>
        <div className='col-xl-6'>
          <ChartsWidget2
            id='sentimentByPlatforms'
            className='mb-5'
            data={sentimentByPlatforms}
            functionSubmit={updateTestSentimentCountByPlatformsFunction}
            functionDownload={downlodTestCountBySentimentAndPlatform}
            isDownloadContinue={isDownloadContinue_TestCountBySentimentAndPlatform}
            texts={[LanguageHelp('Positive'), LanguageHelp('Negative'), LanguageHelp('Neutral')]}
            mainLabel={LanguageHelp('Platform Statistics')}
            sideLabel={LanguageHelp('Happiness Score Compared to Platforms')}
            options={competitors}
            selectedOption={sentimentByPlatforms_Competitor}
            selectedDate={sentimentByPlatforms_Date}
            isHorizontal={true}
            height='325px'
            warnings={[
              { url: '/apps/artificial-intelligence/subjects', message: LanguageHelp("You can add subjects from the 'Artificial Intelligence/Subjects page.") },
              { url: '/crafted/channels', message: LanguageHelp("You can add platforms and turn on daily data collection from the 'Settings/Channels' page.") },
            ]}
            isCompetitorControl={true} />
        </div>
        <div className='col-xl-6'>
          <ChartsWidget1
            id='sentimentByPlatforms'
            className='mb-5'
            data={sentimentByPlatforms}
            functionSubmit={updateTestSentimentCountByPlatformsFunction}
            functionDownload={downlodTestCountBySentimentAndPlatform}
            isDownloadContinue={isDownloadContinue_TestCountBySentimentAndPlatform}
            texts={[LanguageHelp('Positive'), LanguageHelp('Negative'), LanguageHelp('Neutral')]}
            mainLabel={LanguageHelp('Platform Statistics')}
            sideLabel={LanguageHelp('Sentiment Analysis Compared to Platforms')}
            options={reviewSubjects}
            selectedOption={sentimentByPlatforms_Competitor}
            selectedDate={sentimentByPlatforms_Date}
            height='325px'
            warnings={[
              { url: '/apps/artificial-intelligence/subjects', message: LanguageHelp("You can add subjects from the 'Artificial Intelligence/Subjects page.") },
              { url: '/crafted/channels', message: LanguageHelp("You can add platforms and turn on daily data collection from the 'Settings/Channels' page.") },
            ]}
            isCompetitorControl={true} />
        </div>
      </div>
      {/* end::Row */}

      {/* begin::Row */}
      <div className='row g-5 g-xl-10 mb-5'>

        <div className='col-xl-6'>
          <ChartsWidget1
            id='sentimentByMonths'
            className='mb-5'
            data={sentimentByMonths}
            functionSubmit={updateTestSentimentCountByMonthsFunction}
            functionDownload={downlodTestCountBySentimentAndMonth}
            isDownloadContinue={isDownloadContinue_TestCountBySentimentAndMonth}
            texts={[LanguageHelp('Positive'), LanguageHelp('Negative'), LanguageHelp('Neutral')]}
            mainLabel={LanguageHelp('Your Statistics')}
            sideLabel={LanguageHelp('Sentiment in the Last Year')}
            options={reviewSubjects}
            selectedOption={LanguageHelp('All Subjects')}
            selectedDate={""}
            height='225px'
            warnings={[]} />
        </div>
        <div className='col-xl-6'>
          <ChartsWidgetLine
            id='sentimentByDays'
            className='mb-5'
            data={sentimentByDays}
            functionSubmit={updateTestSentimentCountByDaysFunction}
            functionDownload={downlodTestCountBySentimentAndDay}
            isDownloadContinue={isDownloadContinue_TestCountBySentimentAndDay}
            texts={[LanguageHelp('Positive'), LanguageHelp('Negative'), LanguageHelp('Neutral')]}
            mainLabel={LanguageHelp('Your Statistics')}
            sideLabel={LanguageHelp('Sentiment in the Last Month')}
            options={reviewSubjects}
            selectedOption={LanguageHelp('All Subjects')}
            height='225px' />
        </div>
      </div>
      {/* end::Row */}

      {/* begin::Row */}
      {/* <div className='row g-5 g-xl-10 mb-5'>

        <div className='col-xl-6'>
          <WordCloud
            className='mb-5'
            title={LanguageHelp('Token Sentiment Distribution')}
            name={LanguageHelp('Total Token')}
            functionSubmit={updateTokensForWordCloudFunction}
            functionDownload={downlodTokensForTable}
            isDownloadContinue={isDownloadContinue_TokensForTable}
            words={tokensForWordCloud}
            callbacks={{
              getWordColor: (word: any) => word.positiveCount < word.negativeCount ? "#f1416c" : "#50cd89",
              getWordTooltip: (word: any) => `${word.text} (${LanguageHelp('Positive') + ": " + word.positiveCount + ", " + LanguageHelp('Negative') + ": " + word.negativeCount + ", " + LanguageHelp('Neutral') + ": " + word.neutralCount}) `,
            }}
            height='350px'
            warnings={[
              { url: '/apps/artificial-intelligence/subjects', message: LanguageHelp("You can add subjects from the 'Artificial Intelligence/Subjects page.") },
              { url: '/crafted/channels', message: LanguageHelp("You can add competitors and turn on daily data collection from the 'Settings/Channels' page.") },
            ]}
            isWaringImageMirror={true} />
        </div>
        <div className='col-xl-6'>
          <TablesWidget14
            className='card h-md-96'
            uniqueKey='tokensForTable'
            tableName={LanguageHelp('Token')}
            datas={tokensForTable}
            functionSubmit={updateTokenForTableFunction}
            functionDownload={downlodTokensForTable}
            isDownloadContinue={isDownloadContinue_TokensForTable}
            mainLabel={LanguageHelp('Token Sentiment Distribution')}
            sideLabel={LanguageHelp('Grand Total')}
            warnings={[
              { url: '/apps/artificial-intelligence/subjects', message: LanguageHelp("You can add subjects from the 'Artificial Intelligence/Subjects page.") },
              { url: '/crafted/channels', message: LanguageHelp("You can add competitors and turn on daily data collection from the 'Settings/Channels' page.") },
            ]} />
        </div>
      </div>*/}
      {/* end::Row */}

      {/* begin::Row */}
      <div className='row g-5 g-xl-10 mb-5'>
        <div className='col-xl-12'>
          <ChartsWidgetBubble
            id='sentimentByCompetitorsAndSubjects'
            className='mb-5'
            data={sentimentByCompetitorsAndSubjects}
            functionSubmit={updateTestSentimentCountByCompetitorsAndSubjectsFunction}
            functionDownload={downlodTestCountBySentimentAndCompetitorAndSubject}
            isDownloadContinue={isDownloadContinue_TestCountBySentimentAndCompetitorAndSubject}
            texts={[LanguageHelp('Positive'), LanguageHelp('Negative'), LanguageHelp('Neutral')]}
            mainLabel={LanguageHelp('Competition Statistics')}
            sideLabel={LanguageHelp('Sentiment and Subject Analysis Compared to Competitors')}
            options={reviewSubjects}
            selectedOption={sentimentByCompetitors_Subject}
            selectedDate={sentimentByCompetitors_Date}
            height='550px'
            isCompetitorControl={true}
            warnings={[
              { url: '/apps/artificial-intelligence/subjects', message: LanguageHelp("You can add subjects from the 'Artificial Intelligence/Subjects page.") },
              { url: '/crafted/channels', message: LanguageHelp("You can add competitors and turn on daily data collection from the 'Settings/Channels' page.") },
            ]}
            isWaringImageMirror={true} />
        </div>
      </div>
      {/* end::Row */}

      {/* begin::Row */}
      <div className='row g-5 g-xl-10 mb-5 mb-xl-10'>
        <div className='col-md-12 col-lg-12 col-xl-12 col-xxl-12'>
          <TablesWidget5
            className='card h-md-100'
            datas={channels}
            functionSubmit={updateChannelFunction}
            functionDownload={downlodTestSentimentRateByChannels}
            isDownloadContinue={isDownloadContinue_TestSentimentRateByChannels}
            mainLabel={LanguageHelp('Sentiment Distribution in Channels')}
            sideLabel={LanguageHelp('Total Query')}
            options={reviewSubjects}
            selectedOption={channels_Subject}
            selectedChannelType={channels_ChannelType}
            selectedDate={channels_Date}
            competitors={competitors}
            selectedCompetitor={channels_Competitor} />
        </div>
      </div>
      {/* end::Row */}

      {/* begin::Row */}
      <div className='row g-5 g-xl-10 mb-5'>

        <div className='col-xl-12'>
          <WordCloud
            className=''
            title={LanguageHelp('Subject Sentiment Distribution')}
            name={LanguageHelp('Total Count')}
            functionSubmit={updateSubjectSentimentsForWordCloudFunction}
            functionDownload={downlodSubjectSentimentsForTable}
            isDownloadContinue={isDownloadContinue_SubjectSentimentsForTable}
            words={subjectSentimentsForWordCloud}
            callbacks={{
              getWordColor: (word: any) => getColorCodeFromDivision(word.positiveCount, word.negativeCount),
              getWordTooltip: (word: any) => `${word.text} (${LanguageHelp('Positive') + ": " + word.positiveCount + ", " + LanguageHelp('Negative') + ": " + word.negativeCount + ", " + LanguageHelp('Neutral') + ": " + word.neutralCount}) `,
            }}
            height='450px'
            warnings={[
              { url: '/apps/artificial-intelligence/subjects', message: LanguageHelp("You can add subjects from the 'Artificial Intelligence/Subjects page.") },
              { url: '/crafted/channels', message: LanguageHelp("You can add competitors and turn on daily data collection from the 'Settings/Channels' page.") },
            ]}
            isWaringImageMirror={true} />
        </div>
        <div className='col-xl-12'>
          <TablesWidget14
            className='card h-md-96'
            uniqueKey='subjectSentimentsForTable'
            tableName={LanguageHelp('Subject')}
            datas={subjectSentimentsForTable}
            functionSubmit={updateSubjectSentimentForTableFunction}
            functionDownload={downlodSubjectSentimentsForTable}
            isDownloadContinue={isDownloadContinue_SubjectSentimentsForTable}
            url={'/apps/artificial-intelligence/overview?'}
            mainLabel={LanguageHelp('Subject Sentiment Distribution')}
            sideLabel={LanguageHelp('Grand Total')}
            warnings={[
              { url: '/apps/artificial-intelligence/subjects', message: LanguageHelp("You can add subjects from the 'Artificial Intelligence/Subjects page.") },
              { url: '/crafted/channels', message: LanguageHelp("You can add competitors and turn on daily data collection from the 'Settings/Channels' page.") },
            ]} />
        </div>
      </div>
      {/* end::Row */}

      {/* begin::Row */}
      {/* <div className='row g-5 g-xl-10 mb-5'>

        <div className='col-xl-12'>
          <WordCloud
            className=''
            title={LanguageHelp('Prepared Subject Sentiment Distribution')}
            name={LanguageHelp('Total Count')}
            functionSubmit={updateAutoClassSentimentsForWordCloudFunction}
            functionDownload={downlodAutoClassSentimentsForTable}
            isDownloadContinue={isDownloadContinue_AutoClassSentimentsForTable}
            words={autoClassSentimentsForWordCloud}
            callbacks={{
              getWordColor: (word: any) => word.positiveCount < word.negativeCount ? "#f1416c" : "#50cd89",
              getWordTooltip: (word: any) => `${word.text} (${LanguageHelp('Positive') + ": " + word.positiveCount + ", " + LanguageHelp('Negative') + ": " + word.negativeCount + ", " + LanguageHelp('Neutral') + ": " + word.neutralCount}) `,
            }}
            height='450px'
            warnings={[
              { url: '/crafted/channels', message: LanguageHelp("You can add competitors and turn on daily data collection from the 'Settings/Channels' page.") },
            ]}
            isWaringImageMirror={true} />
        </div>
        <div className='col-xl-12'>
          <TablesWidget14
            className='card h-md-96'
            uniqueKey='autoClassSentimentsForTable'
            tableName={LanguageHelp('Auto Class')}
            datas={autoClassSentimentsForTable}
            functionSubmit={updateAutoClassSentimentForTableFunction}
            functionDownload={downlodAutoClassSentimentsForTable}
            isDownloadContinue={isDownloadContinue_AutoClassSentimentsForTable}
            url={'/apps/artificial-intelligence/overview?'}
            mainLabel={LanguageHelp('Prepared Subject Sentiment Distribution')}
            sideLabel={LanguageHelp('Grand Total')}
            warnings={[
              { url: '/crafted/channels', message: LanguageHelp("You can add competitors and turn on daily data collection from the 'Settings/Channels' page.") },
            ]} />
        </div>
      </div> */}
      {/* end::Row */}

    </>
  )
}

export { DashboardWrapper }
